import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "OrderConfirmEdit" }

import { ref, reactive, computed, Ref } from "vue";
import { useRoute } from "vue-router";
import CartNormalLayout from "../components/CartNormalLayout.vue";
import CartMultiLayout from "../components/CartMultiLayout.vue";
import { useStore } from "vuex";
import axios from "axios";
import { ToEditMeisai } from "@/types/juchu";

//Emitの定義

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderConfirmEdit',
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
emit("toggleGlobalHeader");

const store = useStore();

//別タブで詳細表示---------------------------------
const $route = useRoute();
let isActiveNormal = ref<boolean>(
  Number($route.query.isActiveNormal) === 0 ? false : true
);
let isActiveRenkei = ref<boolean>(false);
let isActiveReference = ref<boolean>(
  Number($route.query.isActiveReference) === 0 ? false : true
);
let meisaiId = ref<number>(0);

//型定義

// interface orderType {
//   meisaiId: number;
//   orderUpdateDate: string;
//   toritsugiCd: string;
//   toritsugiMei: string;
//   toritsugiBansen: string;
//   syotenCd: number;
//   syotenMei: string;
//   syosiCd: number;
//   syosiIsbn: number;
//   syosiMei: string;
//   orderNum: number;
//   tantouMei: string;
//   tanzaku1: string;
//   tanzaku2: string;
//   bikou: string;
//   status: number;
//   selectedMeisaiFlg?: boolean;
//   tanzakuFlg?: false;
// }

// interface orderListType {
//   orderId?: number | string;
//   orderDate?: string;
//   normalCartFlg: boolean;
//   orderStatus: number;
//   toritsugiCd?: string;
//   toritsugiMei?: string;
//   toritsugiBansen?: string;
//   order_array: orderType[];
//   juchuToriokiNo?: string;
// }

// let setToriokiList = (toriokiNo: string, selectOrder: orderListType): void => {
//   selectOrder.juchuToriokiNo = toriokiNo;
// };

// let order_list = reactive([
//   {
//     orderId: 1,
//     orderDate: "2022/01/02",
//     normalCartFlg: true,
//     orderStatus: 2,
//     order_array: [
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         selectedMeisaiFlg: false,
//       },
//       {
//         meisaiId: 2,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 20,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         selectedMeisaiFlg: false,
//       },
//       {
//         meisaiId: 3,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 30,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 3,
//         selectedMeisaiFlg: false,
//       },
//     ],
//   },
//   {
//     orderId: 2,
//     orderDate: "2022/01/02",
//     normalCartFlg: false,
//     orderStatus: 1,
//     toritsugiCd: "000",
//     toritsugiMei: "(株)トーハン",
//     toritsugiBansen: "15-L-34",
//     order_array: [
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         tanzakuFlg: false,
//         jyokenKbn: "",
//         jyokenKikan: "",
//         errorFlg: false,
//       },
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         tanzakuFlg: false,
//         jyokenKbn: "",
//         jyokenKikan: "",
//         errorFlg: false,
//       },
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         juchuToriokiNo: "",
//         selectedMeisaiFlg: false,
//         tanzakuFlg: false,
//         jyokenKbn: "",
//         jyokenKikan: "",
//         errorFlg: false,
//       },
//       {
//         meisaiId: 2,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 20,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         juchuToriokiNo: "",
//         selectedMeisaiFlg: false,
//         tanzakuFlg: false,
//         jyokenKbn: "",
//         jyokenKikan: "",
//         errorFlg: false,
//       },
//       {
//         meisaiId: 3,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 30,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 3,
//         juchuToriokiNo: "",
//         selectedMeisaiFlg: false,
//         tanzakuFlg: false,
//         jyokenKbn: "",
//         jyokenKikan: "",
//         errorFlg: false,
//       },
//     ],
//   },
//   {
//     orderId: 3,
//     orderDate: "2022/01/02",
//     normalCartFlg: true,
//     orderStatus: 1,
//     order_array: [
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         selectedMeisaiFlg: false,
//       },
//       {
//         meisaiId: 2,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 20,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         selectedMeisaiFlg: false,
//       },
//     ],
//   },
//   {
//     orderId: 4,
//     orderDate: "2022/01/02",
//     normalCartFlg: false,
//     toritsugiCd: "000",
//     toritsugiMei: "(株)トーハン",
//     toritsugiBansen: "15-L-34",
//     orderStatus: 2,
//     order_array: [
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         jyokenKbn: "",
//         jyokenKikan: "",
//         status: 1,
//         tanzakuFlg: false,
//         errorFlg: false,
//       },
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         jyokenKbn: "",
//         jyokenKikan: "",
//         status: 1,
//         tanzakuFlg: false,
//         errorFlg: false,
//       },
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         jyokenKbn: "",
//         jyokenKikan: "",
//         status: 1,
//         tanzakuFlg: false,
//         errorFlg: false,
//       },
//       {
//         meisaiId: 1,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 10,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         jyokenKbn: "",
//         jyokenKikan: "",
//         status: 1,
//         tanzakuFlg: false,
//         errorFlg: false,
//       },

//       {
//         meisaiId: 2,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 20,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 1,
//         tanzakuFlg: false,
//       },
//       {
//         meisaiId: 3,
//         orderUpdateDate: "",
//         toritsugiCd: "000",
//         toritsugiMei: "(株)トーハン",
//         toritsugiBansen: "15-L-34",
//         syotenCd: 1,
//         syotenMei: "音羽書店",
//         syosiCd: 32479837,
//         syosiIsbn: 339287397489,
//         syosiMei: "ヲタクに恋は難しい(1)",
//         orderNum: 30,
//         tantouMei: "担当者A",
//         tanzaku1: "",
//         tanzaku2: "",
//         bikou: "",
//         status: 3,
//         tanzakuFlg: false,
//       },
//     ],
//   },
// ]);

//対象のオーダー情報を取得----------------------------------------------------------------
// ここでAPI連携して対象の注文データを取得
// console.log($route.params.id);

// const getjuchuNormal = async () => {
//   try {
//     const url = `${store.getters["getBaseUrl"]}/chumonReference/normalDetails?juchuId=${$route.params.id}`;
//     const res = await axios.get(url, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//       },
//     });
//     console.log(res.data);

//     selectedOrderList.value = res.data;
//     console.log(selectedOrderList.value);
//   } catch (error) {
//     alert("受注情報が取得出来ませんでした。");
//     console.log(error);
//   }
// };
// getjuchuNormal();

// let selectedOrderList = computed((): any => {
//   //orderIdが合致するものを参照
//   const result = order_list.filter((order) => order.orderId == 1);
//   console.log(result);
//   const resultObj = { ...result[0] };
//   console.log(resultObj);
//   return resultObj;
// });

// if ($route.query.meisaiId !== "0") {
//   //明細から表示
//   meisaiId.value = Number($route.query.meisaiId);
// }

// order_list.forEach((order) => {
//   if (order.orderId == Number($route.params.id)) {
//     selectedOrderList.value.order_array.forEach((order: orderType): void => {
//       if (order.meisaiId == meisaiId.value) {
//         order.selectedMeisaiFlg = true;
//       } else {
//         order.selectedMeisaiFlg = false;
//       }
//     });
//     if (order.normalCartFlg) {
//       isActiveNormal.value = true;
//     } else {
//       isActiveNormal.value = false;
//     }
//   }
// });
// if (selectedOrderList.value.orderStatus == 2) {
//   isActiveRenkei.value = true;
// }

//注文情報の編集・削除------------------------------------------------------------
// 通常カート（コンポーネントからemitされる）
// let deleteOrder_fromNormal = (orderIndex: number) => {
//   // @ts-ignore
//   selectedOrderList.value.order_array.forEach((order, index: number) => {
//     if (index == orderIndex) {
//       selectedOrderList.value.order_array.splice(index, 1);
//     }
//   });
// };
// let deleteAllOrder_fromNormal = () => {
//   selectedOrderList.value.order_array = [];
// };

// マルチカート(一旦コメントアウト)
// let deleteOrder = (orderIndex: number) => {
//   // @ts-ignore
//   selectedOrderList.value.order_array.forEach((order, index: number) => {
//     if (index == orderIndex) {
//       selectedOrderList.value.order_array.splice(index, 1);
//     }
//   });
// };

// let addTanzakuInfo = (meisai: orderType) => {
//   selectedOrderList.value.order_array.forEach((order: any) => {
//     if (order.meisaiId == meisai.meisaiId) {
//       order.tanzakuFlg = true;
//     }
//   });
// };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isActiveNormal))
      ? (_openBlock(), _createBlock(CartNormalLayout, {
          key: 0,
          referenceFlg: _unref(isActiveReference)
        }, null, 8, ["referenceFlg"]))
      : _createCommentVNode("", true)
  ]))
}
}

})